import { render, staticRenderFns } from "./MatchesTable.vue?vue&type=template&id=6674b45a&scoped=true&"
import script from "./MatchesTable.vue?vue&type=script&lang=js&"
export * from "./MatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchesTable.vue?vue&type=style&index=0&id=6674b45a&scoped=true&lang=css&"
import style1 from "./MatchesTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674b45a",
  null
  
)

export default component.exports